var React = require('react');

function LessComponent (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons/ic-less"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Simulador-Simples---Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"simul_simples_etapa1-alt2_desktop","transform":"translate(-500.000000, -807.000000)","fill":"#93C13E"},React.createElement("g",{"id":"perguntas","transform":"translate(0.000000, 96.000000)"},React.createElement("g",{"id":"agregado","transform":"translate(0.000000, 388.000000)"},React.createElement("g",{"id":"content","transform":"translate(479.000000, 80.000000)"},React.createElement("g",{"id":"boxes","transform":"translate(0.000000, 100.000000)"},React.createElement("g",{"id":"option"},React.createElement("g",{"id":"btn","transform":"translate(0.000000, 128.000000)"},React.createElement("rect",{"id":"icons/ic-less","x":"21","y":"15","width":"14","height":"2"})))))))))]);
}

LessComponent.defaultProps = {"width":"14px","height":"2px","viewBox":"0 0 14 2","version":"1.1"};

module.exports = LessComponent;

LessComponent.default = LessComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/Counter/images/less.component.svg
// module id = 690
// module chunks = 0